module.exports = ":host {\n  margin: 3px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/notifications/notifications.component.scss
// module id = ./src/app/dashboard/notifications/notifications.component.scss
// module chunks = main